import React from "react";
import "./AdvertiseBanner.css"; // Optional: Add a CSS file for styling if needed

const AdvertiseBanner = () => {
  return (
    <div
      className="advertisement-banner"
      style={{
        backgroundImage: "url(/product-12.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#e6d1d1",
        fontSize: "2rem",

        // width:'90vw',
        // height:'80vh',
        // backgroundImage: "url(/resizeoglogo.png)",
        // backgroundSize: "cover",
        // backgroundPosition: "center",
      }}
    >
      {/* @ S T R I D H A G A */}
    </div>
  );
};

export default AdvertiseBanner;
